import {
	Component,
	NgModule,
	Input,
	OnInit,
	ViewChild,
	ViewContainerRef,
	ComponentFactoryResolver,
	ComponentRef,
	SimpleChanges,
	OnChanges,
	ElementRef,
	OnDestroy,
	EventEmitter,
	Output,
	Renderer2,
	Compiler,
	Injector,
	NgModuleRef,
	ComponentFactory,
} from "@angular/core";
import "rxjs/add/operator/map";
import { CommonModule } from "@angular/common";
import { Subscription } from "rxjs";
import { HttpService } from "../../../services/http.service";

@Component({
	selector: "ng-include",
	templateUrl: "./ng-include.directive.html",
	providers: [],
})
export class NgIncludeDirective {
	@Input("src") public templateUrl: string;
	@ViewChild("loadTemplate", { read: ViewContainerRef, static: true })
	loadTemplate: ViewContainerRef;
	@Output()
	public pageLoaded: EventEmitter<any> = new EventEmitter<any>();
	@Output() public imageEmitter: EventEmitter<any> = new EventEmitter<any>();

	private cmpRef: any;
	public myTemplate: any = "";
	private subscription: Subscription;
	constructor(
		private elementRef: ElementRef,
		private loader: ComponentFactoryResolver,
		private httpService: HttpService,
		private _compiler: Compiler,
		private _injector: Injector,
		private _m: NgModuleRef<any>
	) {
		this.elementRef = elementRef;
	}
	ngOnInit() {
		this.updateTemplate();
	}
	ngOnChanges(changes: SimpleChanges) {
		if (changes.templateUrl.firstChange) {
			return;
		}
		this.updateTemplate();
	}
	ngOnDestroy() {
		this.myTemplate = "";
		this.destroyPrevious();
	}
	updateTemplate() {
		if (this.templateUrl !== "") {
			this.httpService
				.get(this.templateUrl.replace(".html", ".css"))
				.then((resCss: any) => {
					this.loadHtml(this.templateUrl, resCss);
				})
				.catch((err) => {
					this.loadHtml(this.templateUrl);
				});
		}
	}
	public loadHtml(path: string, resCss?: any) {
		this.httpService
			.get(path)
			.then((resHtml: any) => {
				if (resHtml) {
					const css = resCss ? resCss : "";
					this.renderComponents(resHtml, css);
				}
			})
			.catch((err) => {
				console.log("Template not available", err);
			});
	}
	public clickedStuff(data) {
		//console.log("Clicked Stuff",data)
	}
	private renderComponents(template: string, style: string) {
		//console.log("render components", template)
		this.destroyPrevious();
		const component: any = this.createComponent(template, style, []);
		// console.log('component ', component)
		const f = this.createCustomModuleComponentFactory(component);
		this.cmpRef = f.create(this._injector, [], null, this._m);
		this.cmpRef.instance.props = "dynamic";
		//this.subscription = this.cmpRef.instance.toParent.subscribe(event=>this.receivedFromChild(event));
		this.loadTemplate.insert(this.cmpRef.hostView);
		this.pageLoaded.emit("templateLoaded");
		this.cmpRef.instance.imageLoaded.subscribe((v) => {
			this.imageEmitter.emit(v);
		});
	}
	public showText(info: string) {
		if (this.cmpRef && this.cmpRef.instance && this.cmpRef.instance.container) {
			this.cmpRef.instance.container.nativeElement.getElementsByClassName(
				"con-mask"
			)[0].style.display = "none";
			this.cmpRef.instance.container.nativeElement.getElementsByClassName(
				"con-expert"
			)[0].style.display = "block";
			this.cmpRef.instance.container.nativeElement.getElementsByClassName(
				"con-tip"
			)[0].innerHTML = info;
		}
	}
	private createComponent(
		template: string,
		style: string,
		providers: any[]
	): any {
		@Component({
			template: template,
			styles: [style],
			providers: providers,
		})
		class CustomComponent {
			@Output("imageLoaded") public imageLoaded: EventEmitter<any> =
				new EventEmitter<any>();
			@ViewChild("container", { read: ElementRef , static: true})
			container: ElementRef;

			private image: any;
			@ViewChild("imageItem", { read: ViewContainerRef, static: true })
			imageItem: ViewContainerRef;
			public onImageLoad(event) {
				this.imageLoaded.emit(this.imageItem.element.nativeElement);
			}
		}
		console.log(CustomComponent);
		return CustomComponent;
	}
	private createCustomModuleComponentFactory(
		component: any
	): ComponentFactory<any> {
		@NgModule({
			declarations: [component],
			entryComponents: [component],
			imports: [CommonModule],
		})
		class CustomModule {}
		let factory = this._compiler
			.compileModuleAndAllComponentsSync(CustomModule)
			.componentFactories.find(
				(factory) => factory.componentType === component
			);
		return factory;
	}
	private destroyPrevious() {
		if (this.cmpRef) {
			if (this.subscription) {
				this.subscription.unsubscribe();
				this.subscription = null;
			}
			this.cmpRef.destroy();
		}
	}
}
